// Test IDs for the Communities feature. Naming follows the directive in
// ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const COMMUNITIES = {
	navLink: 'app-nav-communities',
	landingPage: 'communities-landing-page',
	detailPage: 'community-detail-page',
	card: 'community-card',
	joinButton: 'community-join-button',
	postComposer: 'community-post-composer',
	post: 'community-post',
	chatPanel: 'community-chat-panel',
};
